import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import {
	KSK1120_R01DetailDto,
	KSK1120_R01Dto,
	KSK1120_R01HeaderDto,
} from "./Dto_KSK1120_R01";
import { KSK1120_R01Filter } from "./Store_KSK1120_R01";

const baseUrl = `${config.apiUrl}/KSK1120_R01`;

export interface KSK1120_R01ListParams {
	compCd?: string;
	startDate?: string;
	endDate?: string;
	customCd?: string;
	itemCd?: string;
	includeCompleted?: boolean;
}

export const getKSK1120_R01Params = (
	filter: Partial<KSK1120_R01Filter>,
): KSK1120_R01ListParams => ({
	compCd: filter.compCd || undefined,
	startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
	endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
	customCd: filter.customCd || undefined,
	itemCd: filter.itemCd || undefined,
	includeCompleted: filter.includeCompleted ?? false,
});

export const getKSK1120_R01List = async (
	option: "search" | "refetch",
	filter: Partial<KSK1120_R01Filter>,
) => getData<ResponseDto<KSK1120_R01HeaderDto[]>>(
	`${baseUrl}/${option}`,
	{ params: getKSK1120_R01Params(filter) },
);

export const getKSK1120_R01AllCount = async (filter: Partial<KSK1120_R01Filter>) =>
	getData<ResponseDto<number>>(
		`${baseUrl}/allCount`,
		{ params: getKSK1120_R01Params(filter) },
	);

export const getKSK1120_R01DetailList = async (transportNo: string, itemNo: string) =>
	getData<ResponseDto<KSK1120_R01DetailDto[]>>(
		`${baseUrl}/detail/${encodeURIComponent(transportNo)}/${encodeURIComponent(itemNo)}`,
	);

export const postKSK1120_R01 = async (data: KSK1120_R01Dto) =>
	postData<KSK1120_R01Dto, ResponseDto<KSK1120_R01Dto>>(baseUrl, data);

export const patchKSK1120_R01 = async (data: KSK1120_R01Dto) =>
	patchData<KSK1120_R01Dto, ResponseDto<KSK1120_R01Dto>>(baseUrl, data);

export const deleteKSK1120_R01 = async (data: KSK1120_R01HeaderDto[]) =>
	postData<KSK1120_R01HeaderDto[], ResponseDto<number>>(`${baseUrl}/delete`, data);

